<template>
  <div>
    <Row v-for="(comment, index) in comments" :key="`${comment.time}-${index}`" type="flex" justify="center" align="middle" class="msg-row">
      <Col span="10">{{comment.time}}</Col>
      <Col span="14">{{comment.content}}</Col>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      defalult: function() {
        return []
      }
    }
  },
  watch: {
    data() {
      this.renderComments();
    }
  },
  data() {
    return {
      comments: []
    }
  },
  methods: {
    renderComments() {
      this.comments = this.data;
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-row{
  padding: 12px;
}
</style>




// WEBPACK FOOTER //
// src/pages/cleaner/order-list/leave-comments.vue